<template>
  <v-card align="center" justify="center" min-width="35vw" max-width="80vw" max-height="85vh" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_FullTradeImage') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text style="background-color: #111111" class="pa-0">
      <v-img max-width="80vw" max-height="75vh" contain :src="tradeImage"/>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FullTradeImage",
  props: {
    tradeImage: String,
  },
  methods: {
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>

</style>
